
<template>
  <div class="infoContainer">
    <img class="picImg" src="../../static/images/pic.jpg" />
    <div class="logo">
         <img class="logoImg" src="../../static/images/logo.png" />
    </div>
    <div class="infoBox">
        <div class="formTitle">
            <div class="line"></div>
            <div class="titleText">
                <div style="font-size:18px;">北京大学</div>
                <div>自信少年牵手行动北大研学之旅（2天研学）</div>
            </div>
        </div>
        <div class="formDescribe">
            <div class="describeRow">
                 <div class="describeCol">
                    <span class="colLabel">研学地点: </span>
                    <span class="colVal"> 北京大学燕园校区</span>
                </div>
            </div>
             <div class="describeRow">
                <div class="describeCol">
                    <span class="colLabel">研学开始日期: </span>
                    <span class="colVal"> 2024年8月3日</span>
                </div>
                <div class="describeCol">
                    <span class="colLabel">研学结束日期: </span>
                    <span class="colVal"> 2024年8月4日</span>
                </div>
            </div>
            <!-- <div class="describeRow">
                <div class="describeCol">
                    <span class="colLabel">审批编号: </span>
                    <span class="colVal"> 北大培训20240961号</span>
                </div>
                <div class="describeCol">
                    <span class="colLabel">计划开班日期: </span>
                    <span class="colVal"> 2024年06月29日</span>
                </div>
            </div>
            <div class="describeRow">
                <div class="describeCol">
                    <span class="colLabel">上课地点: </span>
                    <span class="colVal"> 北京大学燕园校区</span>
                </div>
                <div class="describeCol">
                    <span class="colLabel">计划结业日期: </span>
                    <span class="colVal"> 2024年07月04日</span>
                </div>
            </div>
            <div class="describeCol">
                <span class="colLabel">办学单位: </span>
                <span class="colVal"> 北京大学新闻与传播学院</span>
            </div> -->
        </div>
        <div class="formBox">
            <div class="formTips">
                <div class="line"></div>
                <div class="titleText" style="color: #000000;">报名缴费</div>
            </div>
           <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn" style="letter-spacing: 3px;">身份证姓名</div>
                    <div class="labelEn" style="letter-spacing: 0px;">ID CARD EAME</div>
                </div>
                <input
                type="text"
                maxlength="4"
                v-model="name"
                @input="nameFn"
                placeholder="请输入真实姓名"
                />
            </div>
            <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn">身份证号码</div>
                    <div class="labelEn">ID CARD NO</div>
                </div>
                 <input
                    type="text"
                    maxlength="18"
                    v-model="IDNumber"
                    @input="idNumberFun"
                    placeholder="请输入身份证号"
                    />
            </div>
            <!-- <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn">手机号</div>
                    <div class="labelEn" style="letter-spacing: 2px;">PHONE</div>
                </div>
                <input
                    type="text"
                    maxlength="11"
                    v-model="phone"
                    @input="phoneFn"
                    placeholder="请输入手机号"
                />
            </div> -->
            <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn" style="letter-spacing: 20px;">性别</div>
                    <div class="labelEn" style="letter-spacing: 1px;">CENDER</div>
                </div>
                <el-radio-group v-model="sex" @input="sexFun">
                <el-radio label="1" >男</el-radio>
                <el-radio label="2" >女</el-radio>
                </el-radio-group>
            </div>
            <!-- <div class="formItem">
               <div class="formLabel">
                    <div class="labelZn" style="letter-spacing: 22px;">行业</div>
                    <div class="labelEn" >INDUSTRY</div>
                </div>
                <input
                type="text"
                v-model="industry"
                @input="industryFn"
                placeholder="请输入所在行业"
                />
            </div> -->
             <!-- <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn" style="letter-spacing: 20px;">职务</div>
                    <div class="labelEn" style="letter-spacing: 5px;">POST</div>
                </div>
                <input
                type="text"
                v-model="poster"
                @input="posterFn"
                placeholder="请输入您的职务"
                />
            </div> -->
            <!-- <div class="formItem">
                <div class="formLabel">
                    <div class="labelZn" style="letter-spacing: 22px;">学历</div>
                    <div class="labelEn" >EDUCATION</div>
                </div>
                <input
                type="text"
                v-model="qualification"
                @input="qualificationFn"
                placeholder="请输入您的学历"
                />
            </div> -->

        </div>
        <!-- <div class="formTops">
            <div>
                北京大学—新媒体时代国学智慧与卓越管理高级研修班(第7期)
            </div>
            <div style="font-size: 12px;margin-top:3px;">审批编号:北大培训20240961号</div>
        </div> -->
        <!-- <div class="formItem">
            <span class="home-label">姓名:</span>
            <input
              type="text"
              maxlength="4"
              v-model="name"
              @input="nameFn"
              placeholder="请输入真实姓名"
            />
        </div> -->
        <!-- <div class="formItem">
            <span class="home-label">身份证号:</span>
            <input
              type="text"
              maxlength="18"
              v-model="IDNumber"
              @input="idNumberFun"
              placeholder="请输入身份证号"
            />
        </div>
        <div class="formItem">
            <span class="home-label">手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="phone"
              @input="phoneFn"
              placeholder="请输入手机号"
            />
        </div>
        <div class="formItem">
            <span class="home-label">性别:</span>
             <el-radio-group v-model="sex" @input="sexFun">
              <el-radio label="1" >男</el-radio>
              <el-radio label="2" >女</el-radio>
            </el-radio-group>
        </div> -->
        <!-- <div class="formItem">
            <span class="home-label">行业:</span>
            <input
              type="text"
              v-model="industry"
              @input="industryFn"
              placeholder="请输入所在行业"
            />
        </div>
        <div class="formItem">
            <span class="home-label">职务:</span>
            <input
              type="text"
              v-model="poster"
              @input="posterFn"
              placeholder="请输入您的职务"
            />
        </div>
        <div class="formItem">
            <span class="home-label">学历:</span>
            <input
              type="text"
              v-model="qualification"
              @input="qualificationFn"
              placeholder="请输入您的学历"
            />
        </div> -->
    </div>
    <div
        class="submitBtn"
        style="font-weight: 900; background: #98170c;"
        @click="submitOrder"
        >
        提交报名信息
    </div>
      <div v-if="showMask" class="dialog">
         <div class="maskBox">
            <div class="maskTitle">温馨提示</div>
            <div class="mask-Pricebox">信息提交成功</div>
            <div class="signView">
            <div
                class="btn0"
                style="font-weight: 900; color: #fff; background: #98170c;"
                @click="closeMask"
            >
                关闭网页
            </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
    data(){
        return{
            name:'',
            phone:'',
            IDNumber:'',
            sex:'',
            industry:'',    //行业
            poster:'',      // 职务
            qualification:'',  // 学历
            showMask:false
        }
    },
    mounted() {

    },
    created(){

    },
    methods:{

        // 关闭
        closeMask(){
            this.showMask=false;
            window.WeixinJSBridge.call('closeWindow') 
        },

        // 提交表单  
        async submitForm(){
              let that = this;
              let res = await that.$api.commitInfo({
                    name:that.name,
                    // phone:that.phone,
                    sex:that.sex,
                    // education:that.qualification,
                    identityNum:that.IDNumber,
                    // industry:that.industry,
                    // job:that.poster,
                })
                if(res.data.code == '0000'){
                    that.showMask = true;
                    // this.$alert('提交成功','提示',{
                    // confirmButtonText: '关闭网页',
                    // callback: action => {
                    //     window.WeixinJSBridge.call('closeWindow') 
                    // }
                    // })
                }else{
                    this.$Toast(res.data.data);
                    return
                }

        },



        // 提交
        submitOrder(){
             let reg2 = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;   // 身份证校验
            if (!this.name) {
                this.$Toast("请输入真实姓名");
                return;
            }else if (!this.IDNumber) {
                this.$Toast("请输入身份证号");
                return;
            }else if(!reg2.test(this.IDNumber)){
                this.$Toast("请输入正确身份证号");
                return;
            }
            // else if (this.phone == "") {
            //     this.$Toast("请输入手机号码");
            //     return;
            // }else if (this.phone.length < 11) {
            //     this.$Toast("请输入正确的手机号码");
            //     return;
            // }
            else if(!this.sex){
                this.$Toast("请选择性别");
                return;
            }
            // else if(!this.industry){
            //     this.$Toast("请输入所在行业");
            //     return;
            // }else if(!this.poster){
            //     this.$Toast("请输入您的职务");
            //     return;
            // }else if(!this.qualification){
            //     this.$Toast("请输入学历");
            //     return;
            // }
            this.submitForm()


        },
        // 姓名
        nameFn(e) {
        this.name = e.target.value;
        },
            // 手机号
        phoneFn(val) {
        this.phone = val.target.value;
        },
        // 身份证号
        idNumberFun(val){
        this.IDNumber = val.target.value;
        },
        sexFun(val){
        this.sex = val
        },
        industryFn(val){
            this.industry = val.target.value;
        },
        posterFn(val){
            this.poster = val.target.value;
        },
        qualificationFn(val){
            this.qualification = val.target.value;
        },

    },

}

</script>
<style scoped lang="scss">
.infoContainer{
    background: #fff;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    // background-image: url('../../static/images/bg.png');
}
.picImg{
    width: 100%;
}
.logo{
    width: 100%;
    height: 125px;
    text-align: center;
    .logoImg{
        width: 240px;
        height: 100%;
    }
}
.infoBox{
    width: 100%;
    padding: 12px;
    padding-top: 0px;
    padding-bottom: 40px;
    box-sizing: border-box;
    .formItem{
        // width: 100%;
        // display: flex;
        // flex-direction: row;
        // justify-content: space-between;
        // align-items: center;
        // background: #fff;
        // border-radius: 5px;
        // font-weight: 400;
        // color: #000000;
        // font-size: 12px;
        // line-height: 40px;
        // margin-bottom: 10px;
        // padding: 0px 10px;
        // box-sizing: border-box;
        // border: 1px #999 solid;
        // input {
        //     border: none;
        //     outline: none;
        //     height: 50px;
        //     width: 150px;
        //     font-size: 14px;
        //     border-radius: 5px;
        //     font-weight: 400;
        //     color: #000000;
        //     text-align: right;
        //     box-sizing: border-box;
        //     font-size: 12px;
        // }
        // .el-radio{
        //     width:20px;
        //     height: 20px;
        //     margin-left: 10px;
        //     margin-right: 10px;
        // }
        // .el-radio__input{
        //     margin-left: 10px;
        //     // margin-top: 10px;
        // }
        // .el-radio__label{
        //     display: inline-block;
        //     margin-left: 10px;
        //     margin-top: 10px;
        //     margin-right: 10px;
        // }
    }
}
.submitBtn{
    width: calc(100% - 24px );
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    border-radius: 5px;
    margin-left: 12px;
    margin-bottom: 15px;
    // position: absolute;
    // bottom: 20px;
    // left: 12px;
}

.formTitle{
    width: 100%;
    // background: rgba(215, 214, 213, 0.5);
    background: rgba(183, 181, 178, 0.4);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    .line{
        width: 5px;
        height: 47px;
        background: #98170c;
        margin-right: 8px;
    }
    .titleText{
         color: #000000;
         font-size: 14px;
        font-weight: 500;
    }
}
.formDescribe{
    width: 100%;
    // background: rgba(215, 214, 213, 0.3);
    background: rgba(183, 181, 178, 0.2);
    padding: 20px 10px;
    box-sizing: border-box;
    color: #000000;
    font-weight: 500;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .describeRow{
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        // align-items: center;
        margin-bottom: 5px;
        .describeCol{
            flex: 1;
        }
    }
    .describeCol{
        line-height: 18px;
        vertical-align: middle;
    }
    .colLabel{
        color: #d1453d;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        display: inline-block;
        vertical-align: middle;
    }
    .colVal{
        margin-left: 2px;
        line-height: 18px;
        display: inline-block;
        vertical-align: middle;
    }
}

.formTips{
    width: 100%;
    display: flex;
    margin-bottom: 15px;
    .line{
        width: 5px;
        height: 27px;
        background: #98170c;
        margin-right: 8px;
    }
    .titleText{
         color: #98170c;
         font-size: 18px;
        font-weight: 500;
    }
}
.formBox{
    width: 100%;
    // background: #eeeeed;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding:20px 10px;
    box-sizing: border-box;
    .formItem{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        font-size: 14px;
        .formLabel{
            color: #9c1c17;
            width: 110px;
            .labelZn{
                letter-spacing: 3px;
                font-weight: 500;
                font-size: 16px;
            }
            .labelEn{
                 font-size: 13px;
            }
        }
         input {
            flex: 1;
            border: none;
            outline: none;
            height: 50px;
            // width: 150px;
            // font-size: 14px;
            border-radius: 5px;
            font-weight: 400;
            color: #000000;
            text-align: right;
            padding-right: 8px;
            box-sizing: border-box;
            font-size: 12px;
            background: #fff;
            border: 1px #acacac solid;
        }
        .el-radio-group{
            flex: 1;
            height: 50px;
            border-radius: 5px;
            font-weight: 400;
            color: #000000;
            background: #fff;
            border: 1px #acacac solid;
            text-align: right;
            padding-right: 8px;
            box-sizing: border-box;
            font-size: 12px;
        }
        .el-radio{
            margin-left: 10px;
            margin-right: 10px;
            line-height: 50px;
        }
        .el-radio__input{
            margin-left: 10px;
        }
        .el-radio__label{
            display: inline-block;
            margin-left: 10px;
            margin-top: 10px;
            margin-right: 10px;
            font-size: 14px;
        }
        .el-radio__input.is-checked .el-radio__inner{
            background: #98170c !important;
            border-color: #98170c !important;
        }
        .el-radio__input.is-checked+.el-radio__label{
            color: #98170c !important;
        }
    }

}

.formTops{
    color: #6f4630;
    font-size: 15px;
    margin-bottom: 15px;
}
.dialog {
  position: fixed;
  width: 100vw;
  height: 120vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 100px 28px 130px;
  box-sizing: border-box;
  z-index: 99;
}
.maskBox {
  position: fixed;
  top: 10%;
  left: 10%;
  width: 80%;
  background: #fff;
  border-radius: 9px;
  padding-bottom: 15px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.maskTitle {
  width: 100%;
  height: 40px;
  font-weight: 900;
  text-align: center;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  margin-bottom: 10px;
  background-color: #98170c;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.mask-Pricebox {
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
  color: #98170c;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0px 16px;
  min-height: 40px;
  background: #fff;
}
.signView {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30rpx;
  box-sizing: border-box;
  padding: 0 20px;
}
.btn0 {
  width: 100%;
  height: 35px;
  border-radius: 6px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
}


</style>
<style>
 .el-radio__input.is-checked .el-radio__inner{
        background: #98170c !important;
        border-color: #98170c !important;
    }
    .el-radio__input.is-checked+.el-radio__label{
        color: #98170c !important;
    }
</style>





